import { render, staticRenderFns } from "./student_list.vue?vue&type=template&id=c5459194&scoped=true"
import script from "./student_list.vue?vue&type=script&lang=js"
export * from "./student_list.vue?vue&type=script&lang=js"
import style0 from "./student_list.vue?vue&type=style&index=0&id=c5459194&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5459194",
  null
  
)

export default component.exports